import { render, staticRenderFns, recyclableRender, components } from "./store-info.vue?vue&type=template&id=73f9b8c2&scoped=true&"
var renderjs
import script from "./store-info.vue?vue&type=script&lang=js&"
export * from "./store-info.vue?vue&type=script&lang=js&"
import style0 from "./store-info.vue?vue&type=style&index=0&id=73f9b8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f9b8c2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/confirm-order/store-info.vue"
export default component.exports